import React from 'react';
import '../styles/SummaryTable.css';

const SummaryTable = ({ data }) => {
  const topics = Object.entries(data.topics);

  return (
    <div className="summary-section">
      <h2>Summary</h2>
      <table className="summary-table">
        <thead>
          <tr>
            <th colSpan="2">Input values</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Dataset:</strong></td>
            <td dangerouslySetInnerHTML={{ __html: `${data.dataset} (<a href="${data.datasetUrl}" target="_blank" rel="noopener noreferrer">${data.datasetUrl}</a>)` }}></td>
          </tr>
          <tr>
            <td><strong>Ethnicity:</strong></td>
            <td>{data.ethnicity.join(', ')}</td>
          </tr>
          <tr>
            <td><strong>Location:</strong></td>
            <td>{data.location.join(', ')}</td>
          </tr>
        </tbody>
      </table>

      <h3>Topics:</h3>
      <table className="topics-table">
        <tbody>
          {topics.map(([sector, topics]) => (
            <React.Fragment key={sector}>
              <tr>
                <td colSpan="2" className="sector-header"><strong>{sector}</strong></td>
              </tr>
              {topics.map((topic, index) => (
                <tr key={index}>
                  <td>{topic.question}</td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SummaryTable;
